export default {
    price1Per0FromSqrtPriceX96(sqrtPriceX96, decimals0, decimals1, outDecimals = 18) {
        const Q96 = 2n ** 96n;
        const Q192 = Q96 * Q96;

        // 转 BigInt
        const sqrtX96 = BigInt(sqrtPriceX96);

        // 原始价格 (没有考虑代币小数差)
        let numerator = sqrtX96 * sqrtX96; // (sqrtPriceX96)^2
        let denominator = Q192;

        // 小数位修正：price * 10^(dec0 - dec1)
        if (decimals0 >= decimals1) {
            numerator = numerator * (10n ** BigInt(decimals0 - decimals1));
        } else {
            denominator = denominator * (10n ** BigInt(decimals1 - decimals0));
        }

        // 返回小数字符串
        return this.divToDecimalString(numerator, denominator, outDecimals);
    },

// 辅助函数：BigInt 除法 -> 小数字符串
    divToDecimalString(numer, denom, decimals = 18) {
        if (denom === 0n) throw new Error("Division by zero");
        const intPart = numer / denom;
        const rem = numer % denom;

        const scale = 10n ** BigInt(decimals);
        const fracPart = (rem * scale) / denom;

        const fracStr = fracPart.toString().padStart(decimals, "0").replace(/0+$/, "");
        return fracStr.length ? `${intPart.toString()}.${fracStr}` : intPart.toString();
    },

    invertDecimalString(x, outDecimals = 18) {
        if (!x || x === "0") throw new Error("Cannot invert zero/empty");

        const [intPart, fracPart = ""] = x.split(".");
        const scale = 10n ** BigInt(fracPart.length);
        const numerator = scale;
        const denominator = BigInt(intPart + fracPart);

        return this.divToDecimalString(numerator, denominator, outDecimals);
    }
}